/**
 *  AdminEditUserSource implements interactions with the /api/admin/users endpoints
 */
import {adminApi} from '../../api';
import EditUser from 'records/EditUser';

export default {
  retrieve(userId) {
    return adminApi.getJson(`/users/${userId}`).then(editUser => new EditUser(editUser));
  },

  /**
   * Submit the user form's data to save/edit a user
   * @param userId {string}
   * @param fieldValues {Object}
   */
  submit(userId, fieldValues) {
    return adminApi
      .putJson(`/users/${userId}`, fieldValues)
      .then(editUser => new EditUser(editUser));
  },

  /**
   * Create a new user using the given fieldValues
   * @param fieldValues {Object}
   */
  create(fieldValues) {
    return adminApi.postJson('/users/', fieldValues);
  },
};
